import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Provider, { DispatchProps, OwnProps, StateProps } from './ProviderListScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getProviders } from 'src/store/actions/provider-actions';
import { selectNameSerTypes } from 'src/store/selectors/service-types-selectors';
import { getServiceLocations } from 'src/store/actions/service-location-actions';
import { selectNameSerLocations } from 'src/store/selectors/service-location-selectors';
import { selectProviders } from 'src/store/selectors/providers-selectors';
import { getServiceTypes } from 'src/store/actions/service-type-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: selectProviders(state),
        inProgress: state.providers.inProgress,
        // data: state.providers.data,

        serviceTypes: selectNameSerTypes(state),
        serviceLocations: selectNameSerLocations(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getProviders(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
    };
}

const ProviderScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(Provider);

export default ProviderScreen;
